import { useGetUserLimits } from '../useGetUserLimits';

export const useBusinessLimit = () => {
  const { businessLimit } = useGetUserLimits();

  return businessLimit;
};
